/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".pad0[_ngcontent-%COMP%]{padding:0}.headerLBL[_ngcontent-%COMP%], .unitbox[_ngcontent-%COMP%]{display:inline-block}.headerLBL[_ngcontent-%COMP%]{padding-right:15px;font-size:1.4rem}.unitboxsize[_ngcontent-%COMP%]{display:inline-block;width:70px;margin-left:15px}"];
export { styles as styles };

